import styled from "styled-components";

export const ConfirmModalStyled = styled.aside`
  align-items: center;
  color: #24272e;
  display: flex;
  gap: 1rem;
  flex-direction: column;
  width: 100%;
  .confirm-modal-icon {
    align-items: center;
    background-color: #e9e9ed;
    border-radius: 50%;
    color: #24272e;
    display: flex;
    font-size: 3.75rem;
    height: 80px;
    justify-content: center;
    width: 80px;
  }
  .confirm-modal-title {
    font-size: 1.25rem;
    font-weight: 600;
  }
  .confirm-modal-copy {
    line-height: 1.5em;
    text-align: center;
  }
`;
